/// <reference types="waypoints"/>
// import 'modernizr';
import 'core-js/stable/dom-collections/for-each';
import 'waypoints/lib/noframework.waypoints';
import { inOutSine } from 'ease-component';
import { ScrollTo } from './scroll-to';
import { Tab } from './tab';
import { Collapse } from './collapse';
import { CollapseMenu } from './collapse-menu';
import { SwiperSlider } from './swiper-slider';
import './../scss/_variables';
import 'bootstrap/scss/bootstrap';
import './../scss/main';
class Application {
    constructor() {
    }
    run() {
        this.initScrollTo();
        this.initTab();
        this.initCollapse();
        this.initCollapseMenu();
        this.initSlider();
        this.initWaypoints();
    }
    initScrollTo() {
        const items = document.querySelectorAll('.j-scroll-component');
        items.forEach(item => {
            let element = item;
            if (element.dataset.scrollHref) {
                let scrollTarget = document.querySelector(element.dataset.scrollHref);
                if (scrollTarget !== null) {
                    new ScrollTo({
                        triggerElement: item,
                        destination: scrollTarget,
                        ease: inOutSine,
                        scrollDuration: element.dataset.scrollDuration ? parseInt(element.dataset.scrollDuration) : 1000
                    });
                }
            }
        });
    }
    initTab() {
        const tabList = document.querySelectorAll('.j-tab-component');
        tabList.forEach(tab => {
            new Tab({
                element: tab
            });
        });
    }
    initCollapse() {
        const collapseList = document.querySelectorAll('.j-collapse-component');
        collapseList.forEach(collapse => {
            new Collapse({
                element: collapse
            });
        });
    }
    initCollapseMenu() {
        const collapseList = document.querySelectorAll('.j-collapse-menu-component');
        collapseList.forEach(collapse => {
            new CollapseMenu({
                element: collapse
            });
        });
    }
    initSlider() {
        const sliderList = document.querySelectorAll('.j-slider-component');
        sliderList.forEach(slider => {
            new SwiperSlider({
                element: slider
            });
        });
    }
    initWaypoints() {
        const items = document.querySelectorAll('.j-waypoint-target');
        items.forEach(item => {
            const element = item;
            if (!element.dataset.offsetElement) {
                return;
            }
            const offsetElement = document.querySelector(element.dataset.offsetElement);
            if (offsetElement === null) {
                return;
            }
            new Waypoint({
                element: offsetElement,
                offset: () => {
                    return -offsetElement.offsetHeight;
                },
                handler: (direction) => {
                    if (direction == 'down') {
                        element.classList.add('d-block');
                    }
                    else {
                        element.classList.remove('d-block');
                    }
                }
            });
        });
    }
}
document.addEventListener('DOMContentLoaded', function () {
    new Application().run();
});
